import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { CellEditEndingEventArgs, CellRangeEventArgs, CellType, FlexGrid, GridPanel } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, Vendor } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    templateUrl: './vendors.component.html',
    standalone: true,
    imports: [FormsModule, ActionToolbarCount, ActionToolbarSearchComponent, WjGridModule, AutoSizeDirective, WjGridFilterModule],
})
export class VendorsComponent extends BaseComponent {
    faSearch = faSearch
    grid: Grid<Vendor>
    itemIds: any[] = []
    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.UsersEdit])
    }

    constructor() {
        super()
        this.grid = new Grid<Vendor>(this.services).isReadOnly(false).filterBy(item => [item.name])
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.vendors.queryAll()).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.grid.items = result[0]
                },
            }),
        )
    }

    cellEditEnded(flexGrid: FlexGrid, args: CellEditEndingEventArgs) {
        if (args.cancel) return
        this.bulkUpdate([flexGrid.rows[args.row].dataItem])
    }

    pasting(flexGrid: FlexGrid, args: CellRangeEventArgs) {
        if (args.cancel) return
        const rng = args.range
        const itemIds: string[] = []
        let row = Math.min(rng.row, rng.row2)
        const row2 = Math.max(rng.row, rng.row2)
        for (row; row <= row2; row++) {
            const dataItem = flexGrid.rows[row].dataItem
            itemIds.push(dataItem.id)
        }

        // Since the grid will sort and filter the pasted cells before the 'onCellPasted' even fires,
        // we need to keep a record of the items we are changing, so they wrong items don't get send to the server.
        this.itemIds = itemIds
    }

    pasted(flexGrid: FlexGrid, args: CellRangeEventArgs) {
        if (args.cancel) return
        const itemsToSave = flexGrid.collectionView.items.filter(x => this.itemIds.indexOf(x.id) > -1)
        this.bulkUpdate(itemsToSave)
    }

    bulkUpdate(items: Vendor[]) {
        this.services.data.put('api/Vendor/BulkUpdate', items).subscribe(
            () => {
                this.services.data.materialTickets.updateSort()
                this.grid.refresh()
            },
            () => {
                this.services.notification.error('The invoicing changes were not successfully saved')
            },
        )
    }

    itemFormatter = (panel: GridPanel, r, c, cell: HTMLDivElement) => {
        if (panel.cellType === CellType.Cell) {
            const col = panel.grid.columns[c]
            cell.classList.remove('yellow-cell')
            if (col.binding !== 'name') {
                cell.classList.add('yellow-cell')
            }
        }
    }
}
